import { constants } from "ethers";
import { VaultDetails } from "../store/vaults";
import { calculateTVL } from "./calculateTVL";

export function calculateVaultUSDBalance(vault: VaultDetails): number {
  const { balance, totalSupply, tokenPrice0, tokenPrice1 } = vault;
  const { reserves0, reserves1 } = vault;
  if(totalSupply.gt(constants.Zero) && balance && balance.gt(constants.Zero)) {
    const share0 = reserves0.mul(balance).div(totalSupply);
    const share1 = reserves1.mul(balance).div(totalSupply);
    if(tokenPrice0 && tokenPrice1) {
      const balance0 = calculateTVL(share0, vault.token0.decimals, tokenPrice0);
      const balance1 = calculateTVL(share1, vault.token1.decimals, tokenPrice1);
      return balance0 + balance1;
    } else
      return 0;
  } else
    return 0;
}